exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-backdrop {\n  opacity: 0.8;\n}\n.modal-dialog .modal-header .btn-close {\n  background: none;\n  border: none;\n}\n.modal-dialog .modal-content {\n  border: 0;\n  border-radius: 0;\n  box-shadow: 0 0 40px 10px rgba(0, 0, 0, 0.2);\n}\n.modal-dialog .modal-content .modal-body label {\n  font-size: 14px;\n}\n.post-form-modal__footer-row {\n  margin: 0 -15px;\n}\nh4 {\n  font-size: 1.25rem;\n}", ""]);

// exports
